// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSection-module__container--1--4L","title":"FormSection-module__title--_xn3X","grid":"FormSection-module__grid--1TIRJ"};